import React from 'react';
import PropTypes from 'prop-types';

/**
 * PanelHeading - A wrapper that renders a standard HTML p with Bulma class names
 *
 * This component accepts the same props as Bloomer PanelHeading for easy migration
 */
const PanelHeading = ({ className, children, style, ...props }) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['panel-heading'];

    // Add custom class names
    if (className) {
      classes.push(className);
    }

    return classes.join(' ');
  };

  return (
    <p className={getClassNames()} style={style} {...props}>
      {children}
    </p>
  );
};

PanelHeading.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

PanelHeading.defaultProps = {
  className: '',
  style: {},
  children: null,
};

export default PanelHeading;
